// Paylaşılan EmptyState — liste boş veya hata durumlarında kullanılan görsel state
// Kullanım:
//   <EmptyState icon={<PackageIcon/>} title="Stok yok"
//     description="Henüz stok eklenmemiş"
//     action={<Button>+ Yeni Stok</Button>} />
//
//   <EmptyState variant="error" title="Bir hata oluştu"
//     description={msg} action={<Button onClick={retry}>Tekrar Dene</Button>} />
import React from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_ICON = (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

export default function EmptyState({
  icon,
  title = null,           // null ise i18n default kullanılır
  description,
  action,
  variant = 'default',   // 'default' | 'error' | 'success'
  compact = false,
  className = '',
}) {
  const { t } = useTranslation();
  title = title || t('ui.noData');
  return (
    <div className={['ui-empty', `ui-empty-${variant}`, compact ? 'compact' : '', className].filter(Boolean).join(' ')}>
      <div className="ui-empty-icon">{icon || DEFAULT_ICON}</div>
      {title && <div className="ui-empty-title">{title}</div>}
      {description && <div className="ui-empty-desc">{description}</div>}
      {action && <div className="ui-empty-action">{action}</div>}
    </div>
  );
}
